var map = {
	"./en.json": 400,
	"./zh-hk.json": 904
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 903;


//////////////////
// WEBPACK FOOTER
// ./src/resource/intl ^\.\/.*\.json$
// module id = 903
// module chunks = 0